import { render, staticRenderFns } from "./FlyerValidityDates.vue?vue&type=template&id=32efd912&scoped=true"
import script from "./FlyerValidityDates.vue?vue&type=script&lang=js"
export * from "./FlyerValidityDates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32efd912",
  null
  
)

export default component.exports